import * as React from 'react';
import Typography from '../Typography/index.js';

var SubmissionMessage = function SubmissionMessage() {
  return /*#__PURE__*/React.createElement(Typography, {
    className: "leshen-form-submission-message",
    variant: "body"
  }, "Thank you for your submission.");
};
var SubmissionMessage$1 = SubmissionMessage;

export { SubmissionMessage$1 as default };
//# sourceMappingURL=SubmissionMessage.js.map
